
import React from 'react';
import { useRoutes } from 'react-router-dom';
import { authorRouter } from './AuthRouter'

const Routers = props => {

  const routes = authorRouter.map((item, index) => {
    if (index < 2) {
      return item
    }
    else {
      if (item.children?.length) {
        return {
          path: item.path,
          element: item.element,
          auth: item.auth,
          children: item.children.map(child => {
            return {
              path: child.path,
              element: child.element
            }
          })
        }
      }
      else {
        return {
          path: item.path,
          element: item.element,
        }
      }
    }
  })


  const elements = useRoutes(routes)

  return elements
}

export default Routers;